module.exports = __webpack_public_path__ + "static/media/saudi-arabia.1c79a174.svg";